import { useTranslations } from 'next-intl';
import { EditReceipt, Mark } from '@/components/icons';
import CardFooter from '@/components/user/address/card-footer';
import { Ping } from '../icons';

function AddressCard({
  address,
  handleEdit,
  handleDefaultAddress,
  isMutating,
  isDefault,
  mage,
  onDeleteSuccess,
}) {
  const t = useTranslations('');

  return (
    <div className='border-border relative w-full rounded-lg border md:h-fit lg:h-full'>
      <div
        className={`flex h-10 items-center justify-between rounded-t-lg px-4.5 py-2 max-lg:h-9.25 max-sm:h-[34px] ${
          isDefault && 'bg-gray-100'
        }`}
      >
        <button
          onClick={() =>
            isDefault || isMutating ? null : handleDefaultAddress(address)
          }
          disabled={isMutating || isDefault}
          className={`text-primary flex items-center gap-2 transition-all ${
            isDefault
              ? 'cursor-default font-bold'
              : isMutating
                ? 'cursor-not-allowed opacity-50'
                : 'hover:text-primary-dark cursor-pointer underline'
          }`}
        >
          {isMutating && <Ping />}
          <span className='max-lg:text-[15px] max-md:text-sm max-sm:text-xs'>
            {isDefault ? t('user.default_key') : t('user.mark_as_default_key')}
          </span>
        </button>
      </div>

      <div className='px-3.5 pt-3.5 pb-3'>
        <div className='flex flex-col gap-1.5'>
          <h3 className='font-bold max-lg:text-sm max-sm:text-xs max-sm:font-bold'>
            {address.firstname} {address.lastname}
          </h3>
          <p className='max-lg:text-sm max-sm:text-xs max-sm:font-semibold'>
            {address?.region?.region_code || ''}
            <span>-</span>
            {address?.region?.region || ''}
          </p>
          <p
            className='line-clamp-2 max-lg:text-sm max-sm:text-xs max-sm:font-normal'
            title={address.street.join(', ')}
          >
            {address.street.join(', ')}
          </p>
        </div>

        <div className='flex justify-between pt-3.5 max-lg:items-center max-sm:pt-2.5 lg:flex-col lg:gap-3.5'>
          <div className='flex items-center gap-2'>
            <Mark className='size-5.5 max-lg:size-5 max-sm:text-[#00A195]' />
            <p className='font-bold max-lg:text-sm max-sm:text-xs'>
              {'0'.concat(address.telephone?.slice(-9))}
            </p>
          </div>

          <div className='flex items-center justify-between gap-4'>
            <div className='flex items-center gap-2'>
              <EditReceipt className='size-5.5 max-lg:size-5 max-sm:size-3.5' />
              <button
                onClick={() => handleEdit(address)}
                disabled={isMutating}
                className='text-primary hover:text-primary-dark cursor-pointer underline max-lg:text-sm max-sm:text-xs'
              >
                {t('user.edit_address_key')}
              </button>
            </div>

            {!isDefault && (
              <CardFooter
                id={address?.id}
                onDeleteSuccess={onDeleteSuccess}
                mage={mage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddressCard;
